module.exports = __webpack_public_path__ + "static/media/RKBrowserw522@1x.320ee111.jpg";